import * as React from "react";
const SvgTextIconsDocumentLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#2175D9", fillRule: "evenodd", d: "M15.1 16V5.161l-.024.001.008-.008L10.116.033V0H1.5v16zm-1.6-1.6H3.1V1.6h6.3v5.01H11V6.6h2.5zM11 3.243l1.705 1.758H11zM8.7 9.6V8h-4v1.6zm3.2 3.2v-1.6H4.7v1.6z" }));
export default SvgTextIconsDocumentLine;
